<template>
  <div :class="pageSetInfo.listStyleSet.cellContainerOpenMode == 1?'kw_list_cell':''">
        <div :style="pageSetInfo.listStyleSet.listPageCellWithinLeftBoxStyleSet?pageSetInfo.listStyleSet.listPageCellWithinLeftBoxStyleSet.styleSetCode:''" kwName="listPageCellWithinLeftBoxStyleSet">
          <kw_cell_group>
            <kw_cell v-for="(dataInfo,dataIndex) in dataList" :key="dataIndex"
              :title="(dataInfo.NAME)" :value="(dataInfo.RIGHT)" :data-index="(dataIndex)" @click="listDataClick(dataInfo)" >
              <kw_icon v-if="(dataInfo.ICON)" slot="icon" :type="(dataInfo.ICON)" :size="28" color="#80848f"></kw_icon>
              <div slot="footer" v-if="(pageSetInfo.operaButtonSet.length>0 && pageSetInfo.operaButtonSetIfHide)">
                <!-- 列表的操作按钮 -->
                  <div v-for="(buttonItem,buttonIndex) in pageSetInfo.operaButtonSet" :key="'btm_'+buttonIndex"  >
                    <div v-if="(buttonItem.styleSet.cssStyle && buttonItem.styleSet.cssStyle!=2)">
                      <div v-if="((buttonItem.ifShow && (dataInfo[buttonItem.butTjKey] != 0)))">
                        <button class="cell_btn listButton_1" @click='dataButtonClick(buttonItem,dataInfo)'  :style="buttonItem.styleSet.buttonSetButtonStyleSet?buttonItem.styleSet.buttonSetButtonStyleSet.styleSetCode:''"  kwName="buttonSetButtonStyleSet">
                          {{buttonItem.buttonName}}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
            </kw_cell>
          </kw_cell_group>
        </div>
        <div class="cellRightBox" :style="pageSetInfo.listStyleSet.listPageCellWithinRightBoxStyleSet?pageSetInfo.listStyleSet.listPageCellWithinRightBoxStyleSet.styleSetCode:''" kwName="listPageCellWithinRightBoxStyleSet" v-if="pageSetInfo.listStyleSet.cellContainerOpenMode == 1 && visitSource == 2">
          <kw_list v-if="(rightPageInfo.type==1 && rightPageInfo.ifLoad)" ref="kw_list" id="kw_list" :initPageObj="rightPageInfo" :isLimitButton="isLimitButton"></kw_list>
          <kw_look v-else-if="(rightPageInfo.type==11 && rightPageInfo.ifLoad)" ref="kw_look" :pageInfo="rightPageInfo" @goBack="cancelToFirst" :isLimitButton="isLimitButton"></kw_look>
        </div>
  </div>
</template>

<script>
import pageUtils from '@/js/page/pageUtil.js';
import utils from '@/js/utils/util.js';

// 单行列表
import kw_cell_group from '@/components/kw/kw_cell_group.vue';
// 单行列表
import kw_cell from '@/components/kw/kw_cell.vue';
// 图标库
import kw_icon from '@/components/kw/kw_icon.vue';



export default {
  name: 'kw_list_cell',
  props: {
    pageSetInfo: {
      type: Object,
      value: null
    },
    listFieldSet: {
      type: Array,
      value: null
    },
    //列表数据全部显示
    dataList: {
      type: Array,
      value: null
    },
    //单一一条数据进行显示
    dataInfo: {
      type: Object,
      value: null
    },
    initDataIndex: {
      type: Number,
      value: 0
    },
    //按钮是否根据角色权限限制
    isLimitButton:{
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      // 访问来源 PC:2 或者 H5:3
      visitSource:utils.checkVisitSource(),
      rightPageInfo:{
        type : Object,
        default:{
          ifLoad:false
        }
      }
    };
  },
  created() {
    
  },
  mounted() {
    var that = this;
    if(that.pageSetInfo.listStyleSet.cellContainerOpenMode == 1 && that.dataList.length > 0) {
      pageUtils.listDataClick(that, that.dataList[0]);
    }
  },
  watch:{
  },
  computed:{
  },
  components: {
    kw_cell_group,
    kw_cell,
    kw_icon,
    kw_look:resolve => require(['@/components/look/kw_look.vue'], resolve),
    kw_list:resolve => require(['@/components/list/kw_list.vue'], resolve)
  },
  methods: {
    /**
     * 列表数据点击时 进行跳转
     */
    listDataClick(dataInfo) {
      pageUtils.listDataClick(this, dataInfo);
    },
    /**
     * 列表按钮点击事件
     */
    dataButtonClick: function (detail,dataInfo) {
      pageUtils.dataButtonClick(this,detail,dataInfo);
    },
    /**
     * 取消当前选中页面返回第一个
     */
    cancelToFirst:function(){
      var that = this;
      if(that.pageSetInfo.listStyleSet.cellContainerOpenMode == 1 && that.dataList.length > 0) {
        pageUtils.listDataClick(that, that.dataList[0]);
      }
    }
  }
}
        
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .kw_list_cell{display: flex;justify-content: space-between;flex-wrap:wrap}
  .cell_btn{border: none}
  .cellRightBox{background: #fff;min-height: 700px;width: 76%;margin-top: 20px}
</style>
